import { customFetch } from 'utils/http';
import { HTTPResponseError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { M8Price } from 'services/production/types';

type Params = {
  type: string;
};

export const getComponentPrices = async (
  params: Params
): Promise<M8Price[]> => {
  const response = await customFetch(
    getM8AdminURL(`getComponentPrices?type=${params.type}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return [];
};
